export const environment = {
  production: true,
  // baseUrl: 'http://potool.enteroteam.com',
  // webUrL:'http://potool.enteroteam.com'
  webUrL:'http://localhost:',
  baseUrl: 'http://localhost:4000'
  // webUrL:'http://13.234.37.72',
  // baseUrl: 'http://13.234.37.72:4000'

 
};